import { prop } from 'ramda';

export const keyword = prop('keyword');
export const articleUrl = prop('articleUrl');
export const hideCloseButton = prop('hideCloseButton');
export const darkMode = prop('darkMode');
